import type { ComparisonConfig } from './ComparisonPage';

const HOTELOGIX_ZH: ComparisonConfig = {
  slug: 'hotelstack-vs-hotelogix',
  competitorName: 'Hotelogix',
  heroTitle: 'HotelStack.io 对比 Hotelogix',
  heroSubtitle: '两大领先酒店管理平台的全面比较。了解 HotelStack.io 如何提供更多功能、现代架构和比 Hotelogix 更高的价值。',
  overviewComparison: [
    { label: '模块总数', hotelstack: '36个集成模块', competitor: '15个模块' },
    { label: '技术架构', hotelstack: '云原生SaaS', competitor: '传统云服务' },
    { label: '全球覆盖', hotelstack: '40多个国家', competitor: '主要覆盖亚洲' },
    { label: '渠道管理', hotelstack: '内置（100+ OTA）', competitor: '需付费附加' },
    { label: '预订引擎', hotelstack: 'BookMyRoom.io（免费）', competitor: '基础小工具' },
    { label: '技术支持', hotelstack: '全天候专属支持', competitor: '邮件 + 在线聊天' },
  ],
  featureTable: [
    {
      category: '核心PMS',
      features: [
        { name: '可视化房态板', hotelstack: true, competitor: true },
        { name: '拖拽式入住办理', hotelstack: true, competitor: false },
        { name: '夜审向导', hotelstack: true, competitor: true },
        { name: '宾客账单管理', hotelstack: true, competitor: true },
        { name: '在线入住门户', hotelstack: true, competitor: false },
        { name: '散客预订弹窗', hotelstack: true, competitor: '有限' },
      ],
    },
    {
      category: '收益管理',
      features: [
        { name: '动态定价规则', hotelstack: true, competitor: false },
        { name: '假设场景收益模拟器', hotelstack: true, competitor: false },
        { name: '竞争对手价格监控', hotelstack: true, competitor: false },
        { name: '需求预测', hotelstack: true, competitor: false },
        { name: 'RevPAR分析', hotelstack: true, competitor: '基础' },
      ],
    },
    {
      category: '宾客管理',
      features: [
        { name: '360度宾客档案', hotelstack: true, competitor: '基础' },
        { name: '忠诚度计划管理', hotelstack: true, competitor: false },
        { name: '宾客沟通自动化', hotelstack: true, competitor: '有限' },
        { name: '宾客消费分析', hotelstack: true, competitor: false },
        { name: '证件上传与照片采集', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '餐饮与POS',
      features: [
        { name: 'POS终端', hotelstack: true, competitor: false },
        { name: '餐厅平面布局', hotelstack: true, competitor: false },
        { name: '厨房显示系统', hotelstack: true, competitor: false },
        { name: '客房送餐模块', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '报表与分析',
      features: [
        { name: '快报', hotelstack: true, competitor: true },
        { name: '损益表', hotelstack: true, competitor: false },
        { name: '预订进度报告', hotelstack: true, competitor: false },
        { name: '税务合规报告', hotelstack: true, competitor: '基础' },
        { name: '自定义报表生成器', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '多物业管理',
      features: [
        { name: '连锁酒店仪表盘', hotelstack: true, competitor: true },
        { name: '跨物业分析', hotelstack: true, competitor: false },
        { name: '集中化价格管理', hotelstack: true, competitor: false },
        { name: '品牌设置', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '弹性与离线',
      features: [
        { name: '支持离线的PWA', hotelstack: true, competitor: false },
        { name: '离线操作队列', hotelstack: true, competitor: false },
        { name: '重新连接时后台同步', hotelstack: true, competitor: false },
        { name: '冲突感知对账', hotelstack: true, competitor: false },
        { name: '可安装的前台系统', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '企业与团队销售',
      features: [
        { name: '企业协议价管理', hotelstack: true, competitor: false },
        { name: '团队预订与房间名单', hotelstack: true, competitor: '附加模块' },
        { name: '应收账龄与业绩报表', hotelstack: true, competitor: false },
        { name: '餐厅预订', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '员工与人力资源',
      features: [
        { name: '员工名录与排班', hotelstack: true, competitor: false },
        { name: '薪资处理', hotelstack: true, competitor: false },
        { name: '休假与考勤', hotelstack: true, competitor: false },
        { name: '绩效分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$60+',
    hotelstackNote: '包含全部36个模块。无功能限制。免费入驻和数据迁移。支持EUR、GBP、AED、INR、THB区域定价。',
    competitorNote: '基础套餐模块有限。渠道管理和高级功能需额外付费。',
  },
  advantages: [
    '模块数量超过两倍（36对15），核心功能无附加费用',
    '2024年打造的现代云原生架构，所有设备实时同步',
    '支持6种货币区域定价的多币种系统，40多个国家合规工具',
    '通过BookMyRoom.io内置预订引擎——包含免佣金直接预订',
    '高级收益管理，含动态定价、需求预测和假设场景模拟器',
    '完整的餐饮和POS模块，含餐台管理、厨房显示和客房送餐',
    '更低的起步价格，基础套餐包含更多功能',
    '从Hotelogix免费数据迁移，专属入驻支持',
  ],
  verdict: {
    title: '我们的评价',
    summary: '对于寻求现代化一体式平台的酒店，HotelStack.io是更强的选择。凭借36个模块、内置收益管理、餐饮功能和更低定价，它提供的价值远超Hotelogix。Hotelogix可能适合仅需基础PMS功能的经济型酒店。',
    bestFor: [
      '希望获得无附加费用的现代一体式平台的酒店',
      '需要高级收益管理和动态定价的物业',
      '需要餐饮、POS和客房送餐功能的酒店',
      '需要区域合规和多币种账单的物业',
      '需要集中分析和价格管理的多物业连锁酒店',
    ],
  },
  faqItems: [
    { question: '能否从Hotelogix迁移到HotelStack.io？', answer: '可以。我们的团队负责从Hotelogix完整迁移数据，包括宾客档案、预订历史、房价方案和房间配置。迁移免费，通常在48小时内完成，零停机时间。' },
    { question: 'HotelStack.io是否拥有Hotelogix提供的所有功能？', answer: 'HotelStack.io包含Hotelogix提供的每项功能，另外还有17个额外模块，包括收益管理、餐饮/POS、忠诚度计划、合规工具和高级分析——这些都是Hotelogix所不具备的。' },
    { question: 'HotelStack.io和Hotelogix的定价如何比较？', answer: 'HotelStack.io起价$49/月，包含全部36个模块。提供EUR、GBP、AED、INR和THB区域定价。Hotelogix基础套餐起价约$60/月，渠道管理和其他功能需额外收费。' },
    { question: 'HotelStack.io适合目前使用Hotelogix的小型酒店吗？', answer: '当然适合。我们的入门套餐专为50间客房以下的物业设计，所有功能完全开放。许多小型酒店因额外模块和更低价格而从Hotelogix转向我们。' },
  ],
};

const CLOUDBEDS_ZH: ComparisonConfig = {
  slug: 'hotelstack-vs-cloudbeds',
  competitorName: 'Cloudbeds',
  heroTitle: 'HotelStack.io 对比 Cloudbeds',
  heroSubtitle: '两者都是云原生平台。HotelStack.io提供更多模块、更低定价和Cloudbeds缺乏的完整餐饮/POS功能——全部支持多币种区域定价。',
  overviewComparison: [
    { label: '模块总数', hotelstack: '36个模块', competitor: '20多个模块' },
    { label: '定价', hotelstack: '起价$49/月', competitor: '起价$100+/月' },
    { label: '区域定价', hotelstack: '6种货币', competitor: '仅USD' },
    { label: '餐饮/POS', hotelstack: '内置', competitor: '不可用' },
    { label: '预订引擎', hotelstack: 'BookMyRoom.io（免费）', competitor: '基础小工具' },
    { label: '入驻服务', hotelstack: '免费 + 专属', competitor: '自助服务' },
  ],
  featureTable: [
    {
      category: '核心PMS',
      features: [
        { name: '可视化房态板', hotelstack: true, competitor: true },
        { name: '预订管理', hotelstack: true, competitor: true },
        { name: '团队预订', hotelstack: true, competitor: true },
        { name: '夜审向导', hotelstack: true, competitor: true },
        { name: '在线入住门户', hotelstack: true, competitor: true },
      ],
    },
    {
      category: '区域合规',
      features: [
        { name: '多币种账单', hotelstack: true, competitor: '有限' },
        { name: '区域税务自动化', hotelstack: true, competitor: false },
        { name: '宾客登记合规', hotelstack: true, competitor: false },
        { name: 'GDPR数据保护', hotelstack: true, competitor: true },
        { name: '区域支付网关', hotelstack: true, competitor: '有限' },
        { name: '本地化发票', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '收益管理',
      features: [
        { name: '动态定价', hotelstack: true, competitor: true },
        { name: '收益分析', hotelstack: true, competitor: true },
        { name: '竞争对手价格监控', hotelstack: true, competitor: '附加模块' },
        { name: '假设场景模拟器', hotelstack: true, competitor: false },
        { name: '需求预测', hotelstack: true, competitor: '基础' },
      ],
    },
    {
      category: '餐饮与运营',
      features: [
        { name: 'POS终端', hotelstack: true, competitor: false },
        { name: '客房送餐模块', hotelstack: true, competitor: false },
        { name: '客房清洁管理板', hotelstack: true, competitor: true },
        { name: '维修工单', hotelstack: true, competitor: false },
        { name: '员工排班', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '合规与报表',
      features: [
        { name: '区域税务报告', hotelstack: true, competitor: false },
        { name: '审计追踪', hotelstack: true, competitor: true },
        { name: '损益表', hotelstack: true, competitor: '有限' },
        { name: '自定义报表生成器', hotelstack: true, competitor: true },
      ],
    },
    {
      category: '弹性与离线',
      features: [
        { name: '支持离线的PWA', hotelstack: true, competitor: false },
        { name: '离线操作队列', hotelstack: true, competitor: false },
        { name: '重新连接时后台同步', hotelstack: true, competitor: false },
        { name: '冲突感知对账', hotelstack: true, competitor: false },
        { name: '可安装的前台系统', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '企业与团队销售',
      features: [
        { name: '企业协议价管理', hotelstack: true, competitor: false },
        { name: '团队预订与房间名单', hotelstack: true, competitor: '有限' },
        { name: '应收账龄与业绩报表', hotelstack: true, competitor: false },
        { name: '餐厅预订', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '员工与人力资源',
      features: [
        { name: '员工名录与排班', hotelstack: true, competitor: '附加模块' },
        { name: '薪资处理', hotelstack: true, competitor: false },
        { name: '休假与考勤', hotelstack: true, competitor: false },
        { name: '绩效分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$100+',
    hotelstackNote: '包含全部36个模块。支持EUR、GBP、AED、INR、THB区域定价。免费入驻和迁移。',
    competitorNote: '仅USD定价（$100+/月）。高级功能和集成需额外收费。',
  },
  advantages: [
    '全部36个模块以约一半的价格提供——核心功能无附加费',
    '6种货币区域定价——国际物业无汇率意外',
    '完整的餐饮模块，含POS终端、客房送餐和厨房管理',
    '区域合规工具，含税务自动化、宾客登记和GDPR',
    '通过PaymentHooks.com支持多网关支付（Stripe、PayPal、50多个网关），覆盖全球和本地支付方式',
    '员工管理模块，含薪资、考勤和排班',
    '维修和工单管理，含资产追踪',
    '免费入驻和数据迁移，专属支持团队',
  ],
  verdict: {
    title: '我们的评价',
    summary: 'HotelStack.io以约一半的Cloudbeds价格提供更多模块、更高价值和完整的运营工具。虽然Cloudbeds是基础PMS和渠道管理的可靠平台，但HotelStack.io增加了餐饮/POS、员工管理、维修和高级收益工具——全部包含在基础价格中。',
    bestFor: [
      '希望以更低价格获得完整一体式平台的酒店',
      '需要餐饮、POS和员工管理集于一体的物业',
      '需要区域合规和多币种账单的酒店',
      '偏好专属入驻服务而非自助设置的物业',
      '需要集中分析和价格管理的多物业连锁酒店',
    ],
  },
  faqItems: [
    { question: '能否从Cloudbeds迁移到HotelStack.io？', answer: '可以。我们的入驻团队负责从Cloudbeds完整迁移数据，包括宾客档案、预订历史和房价方案。迁移免费，通常在48小时内完成。' },
    { question: 'HotelStack.io是否支持与Cloudbeds相同的OTA渠道？', answer: '是的。HotelStack.io连接100多个OTA，包括Booking.com、Expedia、Airbnb、Agoda和区域平台。还支持通过Amadeus和Sabre的GDS连接。' },
    { question: '为什么HotelStack.io比Cloudbeds更实惠？', answer: 'HotelStack.io每个套餐都包含全部36个模块，无附加费用。6种货币区域定价进一步降低成本。Cloudbeds高级功能需额外收费，且仅提供USD定价。' },
    { question: 'HotelStack.io适合国际物业吗？', answer: '当然适合。HotelStack.io支持多币种账单、区域税务合规和国际支付网关。40多个国家的酒店使用HotelStack.io管理运营。' },
  ],
};

const MEWS_ZH: ComparisonConfig = {
  slug: 'hotelstack-vs-mews',
  competitorName: 'Mews',
  heroTitle: 'HotelStack.io 对比 Mews',
  heroSubtitle: 'Mews面向企业级酒店，定价较高且需付费实施。HotelStack.io以更低成本提供同样的现代体验和更多模块——包含免费入驻。',
  overviewComparison: [
    { label: '酒店类型', hotelstack: '中小到企业级', competitor: '仅企业级' },
    { label: '定价', hotelstack: '起价$49/月', competitor: '$200+/月' },
    { label: '模块总数', hotelstack: '36个内置', competitor: '15+核心' },
    { label: '餐饮/POS', hotelstack: '内置', competitor: '通过集成' },
    { label: 'UI/UX品质', hotelstack: '现代暗色奢华风格', competitor: '现代简约风格' },
    { label: '入驻服务', hotelstack: '免费 + 专属', competitor: '付费实施' },
  ],
  featureTable: [
    {
      category: '核心PMS',
      features: [
        { name: '云原生架构', hotelstack: true, competitor: true },
        { name: '现代UI/UX', hotelstack: true, competitor: true },
        { name: '实时同步', hotelstack: true, competitor: true },
        { name: '多设备访问', hotelstack: true, competitor: true },
        { name: '夜审自动化', hotelstack: true, competitor: true },
      ],
    },
    {
      category: '区域合规',
      features: [
        { name: '多币种账单', hotelstack: true, competitor: true },
        { name: '区域税务自动化', hotelstack: true, competitor: '仅欧盟' },
        { name: '宾客登记合规', hotelstack: true, competitor: '仅欧盟' },
        { name: 'GDPR数据保护', hotelstack: true, competitor: true },
        { name: '区域支付网关', hotelstack: true, competitor: '有限' },
        { name: '区域定价（6种货币）', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '收益与分销',
      features: [
        { name: '渠道管理', hotelstack: true, competitor: true },
        { name: '动态定价', hotelstack: true, competitor: true },
        { name: '预订引擎', hotelstack: true, competitor: true },
        { name: '收益分析', hotelstack: true, competitor: true },
        { name: '假设场景模拟器', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '运营',
      features: [
        { name: '客房清洁管理', hotelstack: true, competitor: true },
        { name: 'POS/餐饮模块', hotelstack: true, competitor: '通过集成' },
        { name: '员工排班', hotelstack: true, competitor: false },
        { name: '维修/工单', hotelstack: true, competitor: false },
        { name: '宾客沟通', hotelstack: true, competitor: true },
      ],
    },
    {
      category: '定价与支持',
      features: [
        { name: '免费入驻', hotelstack: true, competitor: false },
        { name: '免费数据迁移', hotelstack: true, competitor: false },
        { name: '全天候支持', hotelstack: true, competitor: '工作时间' },
        { name: '无实施费用', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '弹性与离线',
      features: [
        { name: '支持离线的PWA', hotelstack: true, competitor: false },
        { name: '离线操作队列', hotelstack: true, competitor: false },
        { name: '重新连接时后台同步', hotelstack: true, competitor: false },
        { name: '冲突感知对账', hotelstack: true, competitor: false },
        { name: '可安装的前台系统', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '企业与团队销售',
      features: [
        { name: '企业协议价管理', hotelstack: true, competitor: '附加模块' },
        { name: '团队预订与房间名单', hotelstack: true, competitor: true },
        { name: '应收账龄与业绩报表', hotelstack: true, competitor: '附加模块' },
        { name: '餐厅预订', hotelstack: true, competitor: '通过集成' },
      ],
    },
    {
      category: '员工与人力资源',
      features: [
        { name: '员工名录与排班', hotelstack: true, competitor: '通过集成' },
        { name: '薪资处理', hotelstack: true, competitor: false },
        { name: '休假与考勤', hotelstack: true, competitor: false },
        { name: '绩效分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$200+',
    hotelstackNote: '包含全部36个模块。免费入驻和迁移。6种货币区域定价。',
    competitorNote: '企业级定价（$200+/月）。付费实施和入驻。高级支持需额外收费。',
  },
  advantages: [
    '起步价格约低75%，每个套餐包含更多模块',
    '免费入驻和数据迁移，对比Mews的付费实施',
    '完整的餐饮和POS内置，对比Mews需要第三方集成',
    '6种货币区域定价——酒店以本地货币支付',
    '包含员工管理、薪资和排班功能',
    '平台内置维修和工单管理',
    '全天候专属支持，对比Mews的工作时间支持',
    '面向中小型酒店开放，不仅限于企业级——所有套餐包含所有模块',
  ],
  verdict: {
    title: '我们的评价',
    summary: 'Mews是愿意支付高价的企业级酒店的优秀平台。HotelStack.io在现代UX和云架构上与Mews不相上下，同时增加了餐饮/POS、员工管理和维修模块——价格约为四分之一，且包含免费入驻。',
    bestFor: [
      '希望以更可及的价格获得Mews级UX品质的酒店',
      '需要内置餐饮、POS和运营工具的物业',
      '希望免费入驻而无需付费实施的酒店',
      '被Mews企业级定价排除在外的中小型物业',
      '需要集中管理和区域合规的多物业连锁酒店',
    ],
  },
  faqItems: [
    { question: 'HotelStack.io与Mews的UI品质相比如何？', answer: '两个平台都提供现代、直观的界面。HotelStack.io采用专为酒店行业设计的暗色奢华主题，36个完整集成模块可从一个仪表盘访问。Mews采用简洁的极简设计，专注于欧洲工作流程。' },
    { question: 'Mews是否包含餐饮和POS功能？', answer: 'Mews的餐饮和POS需要第三方集成。HotelStack.io包含完整的POS终端、客房送餐模块、厨房显示系统和餐饮管理，作为每个套餐的标准功能。' },
    { question: '能否以更低价格获得与Mews相同的现代体验？', answer: '可以。HotelStack.io提供现代云原生体验，含实时同步、精美UI和36个模块，每月$49，对比Mews每月$200+。入驻和迁移均免费。' },
    { question: 'HotelStack.io是否提供像Mews一样的API集成？', answer: '是的。HotelStack.io提供集成市场，含支付网关、OTA、会计软件和第三方服务的API。我们的API优先架构支持企业级需求的自定义集成。' },
  ],
};

export const COMPARISON_ZH: Record<string, ComparisonConfig> = {
  'hotelstack-vs-hotelogix': HOTELOGIX_ZH,
  'hotelstack-vs-cloudbeds': CLOUDBEDS_ZH,
  'hotelstack-vs-mews': MEWS_ZH,
};
